import React, { useCallback, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormCheckInput from 'react-bootstrap/esm/FormCheckInput';
import FormCheckLabel from 'react-bootstrap/esm/FormCheckLabel';

import CustomTextInput from '../../components/CustomTextInput';
import { actionCreators as ticketsActions } from '../../../config/redux/tickets/actions';
import SelectCitiesPrice from '../../components/SelectCitiesPrice';
import CustomButton from '../../components/CustomButton';
import useLoading from '../../../hooks/useLoading';
import SelectCustomerForm from '../../components/SelectCustomerForm';
import BillingForm from '../../components/BillingForm';

import './SaleTicket.css';

function SaleTicket() {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    control,
    reset,
    watch
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { lastTicketLoading, prices } = useSelector(state => ({
    lastTicketLoading: state.tickets.lastTicketLoading,
    prices: state.prices.prices
  }));
  const currentUser = useSelector(state => state.user.currentUser);

  useLoading(lastTicketLoading);

  const onSubmit = useCallback(
    data => {
      dispatch(ticketsActions.addTicket(data, navigate));
    },
    [dispatch, navigate]
  );

  const commonProps = useMemo(() => ({ errors, register }), [errors, register]);

  const handleCalculate = useCallback(() => {
    const origen = getValues('origen');
    const destino = getValues('destino');
    const puestos = getValues('puestos');

    const price = prices.find(
      p => p.origen === origen && p.destino === destino
    );
    if (price) {
      const total = price.precio * puestos;
      setValue('precio', total);
      setValue('costo', `$ ${total.toLocaleString('es-ES')}`);
      setValue('siigo_product_id', price.siigo_product_id);
    }
  }, [getValues, prices, setValue]);

  const selectProps = useMemo(
    () => ({
      required: true,
      column: 'col-md-3',
      prices,
      control,
      ...commonProps
    }),
    [prices, control, commonProps]
  );

  const handleClose = useCallback(() => navigate('/'), [navigate]);
  const handleCancel = useCallback(() => reset(), [reset]);

  const isBillingEnable = watch('billing');

  return (
    <div>
      <h1>Nuevo Tiquete</h1>
      <form onSubmit={handleSubmit(onSubmit)} id="ticketFormId">
        <SelectCustomerForm
          title={'Cliente'}
          getValues={getValues}
          setValue={setValue}
          name={'nombre'}
          phone={'telefono'}
          {...commonProps}
        />
        <FormCheckInput {...register('billing')} />
        <FormCheckLabel>Facturar</FormCheckLabel>
        {isBillingEnable && (
          <>
            <div className="bill-container">
              <h3>Facturación</h3>
            </div>
            <BillingForm
              commonProps={commonProps}
              getValues={getValues}
              watch={watch}
              setValue={setValue}
            />
          </>
        )}
        <div className="inputs-container">
          <h3>Ruta</h3>
          <hr />
          <div className="row g-3">
            <CustomTextInput
              name={'puestos'}
              required
              {...commonProps}
              title={'PUESTOS'}
              column="col-md-3"
              type={'number'}
              min={1}
              defaultValue={1}
              max={10}
            />
            <SelectCitiesPrice name={'origen'} {...selectProps} />
            <SelectCitiesPrice name={'destino'} {...selectProps} />
            <div className="col-md-2">
              <CustomButton type={'button'} onClick={handleCalculate}>
                Calcular
              </CustomButton>
            </div>
            <CustomTextInput
              name={'siigo_product_id'}
              {...commonProps}
              title={''}
              type={'hidden'}
            />
            <CustomTextInput
              name={'costo'}
              readOnly
              required
              {...commonProps}
              title={'VALOR'}
              column="col-md-3"
            />
          </div>
          <CustomTextInput name={'precio'} {...commonProps} type={'hidden'} />
        </div>
        <div className="inputs-container">
          <h3>Fecha y Hora</h3>
          <hr />
          <div className="row g-3">
            <CustomTextInput
              name={'fecha'}
              type={'date'}
              required
              {...commonProps}
              title={'FECHA'}
              column="col-md-3"
            />
          </div>
        </div>
        <div className="inputs-container">
          <h3>Observaciones</h3>
          <hr />
          <div className="row g-3">
            <CustomTextInput
              name={'observaciones'}
              {...commonProps}
              column="col-md-4"
            />
            <CustomTextInput
              name={'usuario'}
              type={'hidden'}
              value={currentUser.name}
              {...commonProps}
              column="col-md-4"
            />
          </div>
        </div>
        <div className="btn-group">
          <CustomButton type={'submit'}>Guardar</CustomButton>
          <CustomButton
            type={'button'}
            buttonStyle="btn--outline"
            onClick={handleCancel}>
            Cancelar
          </CustomButton>
          <CustomButton
            type={'button'}
            buttonStyle="btn--outline"
            onClick={handleClose}>
            Salir
          </CustomButton>
        </div>
      </form>
    </div>
  );
}

export default SaleTicket;
